import { Location } from '@angular/common';
import { IState } from './../../../shared/store/root.reducer';
import { Breadcrumb } from './../../../shared/domain/breadcrum.entity';
import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Store, select } from '@ngrx/store';


@Component({
  selector: 'app-header-breadcrumb',
  templateUrl: './header-breadcrumb.component.html',
  styleUrls: ['./header-breadcrumb.component.scss']
})
export class HeaderBreadcrumbComponent implements OnInit, OnDestroy {
  @Input() breadcrumb: Breadcrumb;
  @Input() supplierName: string;
  printSubscription: Subscription;
  breadcrumbTitleCssClass: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private store: Store<IState>,
    private location: Location
  ) { }

  ngOnInit() {
    /*this.printSubscription = this.store.pipe(select((state: IState) => state.print))
      .subscribe(printState => {
        this.breadcrumbTitleCssClass = printState.breadcrumbTitleCssClass;
      });*/
  }

  goBack() {
    this.location.back();
  }

  ngOnDestroy() {
    if (this.printSubscription) {
      this.printSubscription.unsubscribe();
    }
  }
}
